import React, { useState } from 'react';
import Modal from '@omilia/modal';
import Dropzone from '@omilia/dropzone';
import Button, { ButtonGroup } from '@omilia/button';
import styled from 'styled-components';

export type Props = {
  isLoading: boolean;
  onUploadFiles: (files: File[]) => void;
  hasError: boolean;
  onClose: () => void;
};

const SContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  & > div > ul {
    margin: 14px 0 0 0;
  }
`;

const SButtonGroup = styled(ButtonGroup)`
  align-self: flex-end;
  margin-top: 20px;
`;

const UploadFileModal = ({
  isLoading = false,
  onUploadFiles,
  hasError,
  onClose,
}: Props) => {
  const [files, setFiles] = useState<File[]>([]);

  const handleUploadFiles = async () => {
    await onUploadFiles(files);

    if (!hasError) {
      onClose();
    }
  };

  return (
    <Modal open glyph="upload" title="Upload files" onClose={onClose}>
      <SContainer>
        <Dropzone
          multiple
          showFileList
          description="Drop files here to upload"
          isLoading={isLoading}
          onChange={setFiles}
        />
        <SButtonGroup>
          <Button
            color="secondary"
            data-test="close-button"
            variant="text"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            data-test="upload-button"
            disabled={files.length < 1}
            loading={isLoading}
            variant="contained"
            onClick={handleUploadFiles}
          >
            Upload
          </Button>
        </SButtonGroup>
      </SContainer>
    </Modal>
  );
};

export default UploadFileModal;
